import { Injectable } from "@angular/core";
import { RidangoEpic, RidangoReduxAction } from "@ridango/core";
import { ActionsObservable } from "redux-observable";
import { of } from "rxjs";
import { switchMap, catchError, map } from "rxjs/operators";
import { IsicCardService } from "../isic-card.service";
import { IsicCardActions } from "./isic-card.actions";

@Injectable({
    providedIn: 'root',
})
export class IsicCardEpic {
    constructor(private actions: IsicCardActions, private service: IsicCardService) {}

    register() {
        return [this.activateIsicCard];
    }

    activateIsicCard = (action$: ActionsObservable<any>) =>
    action$.ofType(IsicCardActions.ACTIVATE_ISIC_CARD).pipe(
        switchMap((action: RidangoReduxAction) => {
            return this.service.activateIsicCard(action.payload).pipe(
                map((d: any) => this.actions.activateIsicCardSuccess(d)),
                catchError((error) => {
                    if (error.name && error.status === 0) {
                        const browserError = { error: error.name };
                        return of(this.actions.activateIsicCardFailed(browserError));
                    }
                    return of(this.actions.activateIsicCardFailed(error));
                })
            );
        })
    );
}